import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { grey5 } from 'approot/shared/styles/colours.style';
import { spacing12 } from 'approot/shared/styles/spacing.style';
import { Box } from 'approot/shared/design-system/box/box.style';

type Props = {
  $contentsOnly?: boolean;
};
export const ComponentImageField = styled(Box).attrs({
  $alignItems: 'center',
  $justifyContent: 'space-between',
})<Props>`
  ${({ $contentsOnly }) =>
    !$contentsOnly &&
    `
    border: 1px solid ${grey5};
    padding: ${rem(spacing12)};
    border-radius: ${rem(borderRadius8)};
    overflow: hidden;
  `}
`;
